module.exports = __webpack_public_path__ + "static/media/tracker_plug_and_play.40cfab93.png";